import React from "react";

export function renderVariants(variants) {
	if (!variants || variants.length === 0) return null;
	const groups = new Map();
	for (const v of variants) {
		const key = v.variant_category_id ?? "__none__";
		const catName = v.variants_category?.name || null;
		if (!groups.has(key)) groups.set(key, { name: catName, items: [] });
		groups.get(key).items.push(v);
	}
	return [...groups.values()].map((group, gi) => {
		const sorted = [...group.items].sort((a, b) => (a.qty === 0 ? -1 : 1) - (b.qty === 0 ? -1 : 1));
		if (sorted.length === 0) return null;
		return (
			<div key={gi} className="variant-group">
				{group.name && <div className="variant-group-name">{group.name}</div>}
				{sorted.map((v, vi) =>
					v.qty === 0
						? <div key={vi} className="variant-exclusion">No {v.name}</div>
						: <div key={vi}>{v.qty}× {v.name}</div>
				)}
			</div>
		);
	});
}

export function renderSubProducts(products) {
	if (!products || products.length === 0) return null;
	const groups = new Map();
	for (const p of products) {
		if (p.qty <= 0) continue;
		const key = p.variant_category_id ?? "__none__";
		const catName = p.variants_category?.name || null;
		if (!groups.has(key)) groups.set(key, { name: catName, items: [] });
		groups.get(key).items.push(p);
	}
	return [...groups.values()].map((group, gi) => {
		if (group.items.length === 0) return null;
		return (
			<div key={gi} className="variant-group">
				{group.name && <div className="variant-group-name">{group.name}</div>}
				{group.items.map((p, pi) => <div key={pi}>{p.qty}× {p.name}</div>)}
			</div>
		);
	});
}
